import { Outlet } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

export function AuthLayout() {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'background.default',
                px: 2,
            }}
        >
            <Typography variant="h4" sx={{ mb: 4, fontWeight: 700, color: 'primary.main' }}>
                Your Own Metric
            </Typography>
            <Box sx={{ width: '100%', maxWidth: 440 }}>
                <Outlet />
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 4 }}>
                © {new Date().getFullYear()} yom.aapastech.com — Privacy-first analytics
            </Typography>
        </Box>
    )
}
